import { Card } from '@material-ui/core'
import Loader from 'react-loader-spinner'
import React from 'react'
import ProductSection from './ProductSection'
import filterOrderItemsByApplication from './filterOrderItemsByApplication'
import { APPLICATION } from '../../constants/application'

export const productSelectorCardStyles = {
  width: 300,
  marginRight: 32,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px 0px',
}

const ProductSelector = ({
  orderItems,
  tableContent,
  selectedProductCode,
  onSelect,
  isLoading,
}) => {
  const entitlements = {
    OnlineTraining: filterOrderItemsByApplication(tableContent,orderItems,APPLICATION.OnlineTraining),
    TECloud: filterOrderItemsByApplication(tableContent, orderItems,APPLICATION.TECloud),
    SmartInsight: filterOrderItemsByApplication(tableContent,orderItems,APPLICATION.SmartInsight),
    ContainerHub:filterOrderItemsByApplication(tableContent,orderItems,APPLICATION.ContainerHub),
    AzureContainerHub:filterOrderItemsByApplication(tableContent,orderItems,APPLICATION.AzureContainerHub),
    ACSDFF: filterOrderItemsByApplication(tableContent, orderItems, APPLICATION.ACSDFF),
  }

  return (
    <Card style={productSelectorCardStyles}>
      {isLoading && <Loader type="ThreeDots" color="grey" />}
      <ProductSection
        entitlements={entitlements}
        tableContent={tableContent}
        selectedProductCode={selectedProductCode}
        onSelect={onSelect}
      />
    </Card>
  )
}

export default ProductSelector
